import React from 'react';
import styled from 'styled-components';

import { Button } from '../../../components/ui/Button';
import type { UserFileKind } from '../../../types/api';

const Form = styled.form`
  display: flex;
  align-items: flex-end;
  gap: var(--space-md);
  margin-bottom: var(--space-lg);
  padding: var(--space-lg);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--surface);
  flex-wrap: wrap;
`;

const Field = styled.div`
  display: flex;
  flex: 1 1 220px;
  flex-direction: column;
  gap: var(--space-xs);
`;

const Label = styled.label`
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
`;

const controlStyles = `
  min-height: 44px;
  padding: var(--space-sm) var(--space-md);
  color: var(--text-primary);
  background: var(--surface);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-sm);
  font: inherit;

  &:focus-visible {
    outline: 3px solid var(--brand-200);
    border-color: var(--brand-600);
  }
`;

const SearchInput = styled.input`
  ${controlStyles}
`;

const Select = styled.select`
  ${controlStyles}
`;

export interface UserFilesFiltersProps {
  search: string;
  kind: UserFileKind | '';
  onSearchChange: (value: string) => void;
  onKindChange: (value: UserFileKind | '') => void;
  onClear: () => void;
}

function parseKind(value: string): UserFileKind | '' {
  if (
    value === 'compliance' ||
    value === 'invoice' ||
    value === 'smart_sorting' ||
    value === 'report'
  ) {
    return value;
  }
  return '';
}

export const UserFilesFilters: React.FC<UserFilesFiltersProps> = ({
  search,
  kind,
  onSearchChange,
  onKindChange,
  onClear,
}) => (
  <Form role="search" onSubmit={(event) => event.preventDefault()}>
    <Field>
      <Label htmlFor="user-files-search">Buscar archivos</Label>
      <SearchInput
        id="user-files-search"
        type="search"
        value={search}
        placeholder="Buscar por nombre"
        onChange={(event) => onSearchChange(event.target.value)}
      />
    </Field>
    <Field>
      <Label htmlFor="user-files-kind">Tipo de archivo</Label>
      <Select
        id="user-files-kind"
        value={kind}
        onChange={(event) => onKindChange(parseKind(event.target.value))}
      >
        <option value="">Todos</option>
        <option value="compliance">Cumplimiento</option>
        <option value="invoice">Facturas</option>
        <option value="smart_sorting">Clasificación IA</option>
        <option value="report">Reportes</option>
      </Select>
    </Field>
    {(search || kind) && (
      <Button variant="tertiary" size="sm" onClick={onClear}>
        Limpiar filtros
      </Button>
    )}
  </Form>
);
